module.exports = __webpack_public_path__ + "img/semrush.3c6e12e5.png";